
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 12.0015C15.6885 12.0009 15.3866 12.1094 15.1467 12.3082L7.14671 18.9748C6.87442 19.2011 6.70319 19.5264 6.67068 19.8789C6.63817 20.2315 6.74706 20.5825 6.97338 20.8548C7.19969 21.1271 7.52491 21.2983 7.87748 21.3308C8.23005 21.3634 8.58109 21.2545 8.85338 21.0282L16 15.0548L23.1467 20.8148C23.2831 20.9256 23.44 21.0083 23.6085 21.0582C23.7769 21.1081 23.9536 21.1242 24.1283 21.1056C24.303 21.0871 24.4723 21.0341 24.6265 20.9499C24.7807 20.8657 24.9167 20.7518 25.0267 20.6148C25.1488 20.4777 25.2413 20.3169 25.2984 20.1424C25.3554 19.9679 25.3758 19.7835 25.3583 19.6007C25.3408 19.418 25.2857 19.2408 25.1965 19.0803C25.1073 18.9199 24.986 18.7795 24.84 18.6682L16.84 12.2282C16.5933 12.0608 16.2975 11.981 16 12.0015Z","fill":"#444748"}})])
          )
        }
      }
    